import { Link } from 'react-router-dom';
import { Gauge, Cog, Truck } from 'lucide-react';
import { displayPrice, formatKm } from '../lib/format';

export const VehicleCard = ({ vehicle }) => {
  const isSold = vehicle.status === 'Sold';
  return (
    <Link
      to={`/trucks/${vehicle.slug}`}
      data-testid="vehicle-card"
      className="group block bg-white border border-[#D9D9D6] rounded-xl overflow-hidden hover:shadow-[0_10px_30px_rgba(36,19,95,0.10)] hover:border-[#D9D9D6] transition-shadow duration-200"
    >
      <div className="relative aspect-[4/3] bg-[#D9D9D6]/30 overflow-hidden">
        {vehicle.thumbnail ? (
          <img
            src={vehicle.thumbnail}
            alt={vehicle.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#D9D9D6]">
            <Truck className="h-12 w-12" />
          </div>
        )}
        {isSold && (
          <span
            data-testid="vehicle-card-sold-badge"
            className="absolute top-3 left-3 bg-[#E4002B] text-white text-xs font-bold px-3 py-1 rounded-full tracking-wider"
          >
            SOLD
          </span>
        )}
        {vehicle.featured && !isSold && (
          <span className="absolute top-3 right-3 bg-[#24135F]/80 text-white text-[10px] font-semibold px-2.5 py-1 rounded-full tracking-wider">
            FEATURED
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-xl text-[#24135F] tracking-wide truncate" title={vehicle.title}>
          {vehicle.title}
        </h3>
        <p className="mt-1">
          <span className="font-heading text-2xl text-[#E4002B] tracking-wide">{displayPrice(vehicle)}</span>
          {!vehicle.poa && <span className="text-[#E4002B] text-xs font-semibold ml-1">+GST</span>}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-[#53565A]">
          <span className="flex items-center gap-1.5">
            <Gauge className="h-3.5 w-3.5 text-[#E4002B]" />
            {formatKm(vehicle.kilometres)}
          </span>
          {vehicle.transmission && (
            <span className="flex items-center gap-1.5">
              <Cog className="h-3.5 w-3.5 text-[#E4002B]" />
              {vehicle.transmission}
            </span>
          )}
          <span className="flex items-center gap-1.5">
            <Truck className="h-3.5 w-3.5 text-[#E4002B]" />
            {vehicle.vehicle_type}
          </span>
        </div>
      </div>
    </Link>
  );
};
